import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import NewButton from 'components/NewButton/index';
import styles from './styles.module.scss';

const CreateNew = () => {
  const intl = useIntl();
  const location = useLocation();
  const activeSubStringFromUrl = location.pathname.split('/');
  const validSubString = [
    'segment1',
    'segment2',
    'segment3',
    'segment4',
    'segment5',
    'segment6',
    'segment7',
    'point-of-sale',
    'dist-channels',
    'users',
    'groups',
    'manual-refs',
  ];

  const isValidSubString = (string: string) => {
    if (validSubString.includes(string)) return true;
    return false;
  };

  if (
    activeSubStringFromUrl.length > 2 &&
    isValidSubString(activeSubStringFromUrl[1]) &&
    activeSubStringFromUrl[2] !== 'new'
  ) {
    const createButtonLink = `/${activeSubStringFromUrl[1]}/new`;

    return (
      <div className={styles.createNew}>
        <NewButton
          text={intl.formatMessage({ id: `${activeSubStringFromUrl[1]}.createNew` })}
          link={createButtonLink}
          asRef
        />
      </div>
    );
  }
  return null;
};

export default CreateNew;
